import computeClassName from '../../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'block rounded-full',
  CLASSNAME_TAB_EXPOSURE: {
    'high': {
      BASE: 'h-1',
      CLASSNAME_IS_TAB_DISABLED: {
        true: {
          CLASSNAME_IS_TAB_ACTIVE: {
            true: 'w-full border-b-4 border-cc-gray-05',
            false: 'w-8 border-b-2 border-transparent' // border-cc-gray-05
          }
        },
        false: {
          CLASSNAME_IS_TAB_ACTIVE: {
            true: 'border-cc-accent-20 transition transition-cc-size-colors duration-150 w-full border-b-4 ease-out',
            false: 'border-transparent transition transition-cc-size-colors duration-150 w-8 border-b-2 ease-in group-hover:border-b-4 group-hover:w-full group-hover:border-cc-accent-20' //border-cc-gray-05
          }
        }
      }
    },
    'low': {
      BASE: 'h-0.5',
      CLASSNAME_IS_TAB_DISABLED: {
        true: {
          CLASSNAME_IS_TAB_ACTIVE: {
            true: 'w-full border-b-2 border-cc-gray-05',
            false: 'w-8 border-b border-transparent' // border-cc-gray-05
          }
        },
        false: {
          CLASSNAME_IS_TAB_ACTIVE: {
            true: 'border-cc-accent-20 transition transition-cc-size-colors duration-150 w-full border-b-2 ease-out',
            false: 'border-transparent transition transition-cc-size-colors duration-150 w-8 border-b ease-in group-hover:border-b-2 group-hover:w-full group-hover:border-cc-accent-20' // border-cc-gray-05
          }
        }
      }
    }
  }
});

function getComputedClassName(propsClassName, tabExposure, isTabActive, isTabDisabled) {
  return `${computeClassName(propsClassName, constants.CLASSNAME_BASE)} ${constants.CLASSNAME_TAB_EXPOSURE[tabExposure].BASE} ${constants.CLASSNAME_TAB_EXPOSURE[tabExposure].CLASSNAME_IS_TAB_DISABLED[isTabDisabled].CLASSNAME_IS_TAB_ACTIVE[isTabActive]}`;
}

export default function CCTabStatusIndicator(
  {
    tabExposure,
    isTabActive,
    isTabDisabled,
    className
  }
  ){
  const computedClassName = getComputedClassName(className, tabExposure, isTabActive, isTabDisabled);
  return <div className={computedClassName}/>;
}
